package pl.mothdigital.neuronowi.navigation

import pl.mothdigital.neuronowi.common.resources.*

sealed class Screen(val route: String) {
    data object Home : Screen("/")
    data object About : Screen("/about/")
    data object Specialists : Screen("/specialists/")
    data object Therapies : Screen("/therapies/")
    data object Contact : Screen("/contact/")
    data object PrivacyPolicy : Screen("/privacy-policy")
    data object TermsAndConditions : Screen("/terms-and-conditions")
    data object ChildProtectionStandards : Screen("/child-protection-standards")
    data object Statut : Screen("/statut")

    // Specjaliści
    data object MagdalenaNowik : Screen(PageRouteResources.MAGDALENA_NOWIK_PAGE)
    data object ZaklinaWykret : Screen(PageRouteResources.ZAKLINA_WYKRET_PAGE)
    data object MartaDybalska : Screen(PageRouteResources.MARTA_DYBALSKA_PAGE)
    data object RadoslawNitschke : Screen(PageRouteResources.RADOSLAW_NITSCHKE_PAGE)
    data object JuliaSiuta : Screen(PageRouteResources.JULIA_SIUTA_PAGE)
    data object PaulinaKonieczna : Screen(PageRouteResources.PAULINA_KONIECZNA_PAGE)
    data object EwaSofinska : Screen(PageRouteResources.EWA_SOFINSKA_PAGE)
    data object PatrycjaOchryniuk : Screen(PageRouteResources.PATRYCJA_OCHRYNIUK_PAGE)
    data object AnnaPetrus : Screen(PageRouteResources.ANNA_PETRUS_PAGE)
    data object MagdalenaBanach : Screen(PageRouteResources.MAGDALENA_BANACH_PAGE)

    // Terapie
    data object TherapyMiofunctional : Screen("/therapies/terapia-miofunkcjonalna/")
    data object TherapyNeurotactile : Screen("/therapies/terapia-neurotaktylna/")
    data object TherapyLogopedic : Screen("/therapies/terapia-logopedyczna/")
    data object TherapySensoryIntegration : Screen("/therapies/integracja-sensoryczna/")
    data object TherapyHand : Screen("/therapies/terapia-reki/")
    data object TherapyPsychological : Screen("/therapies/wsparce-psychologiczne/")
    data object TherapyPhysio : Screen("/therapies/fizjoterapia/")
    data object TherapyAuditory : Screen("/therapies/terapia-sluchowa/")

    companion object {
        private val values = listOf(Home, About, Specialists, Therapies, Contact)

        fun takeRoute(route: String): Screen? {
            return values.firstOrNull { it.route == route }
        }
    }
}
